import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconProduct = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 39.98 39.98",
	fill: "currentColor",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", {}),
		/* @__PURE__ */ _jsx("title", { children: "Asset 3" }),
		/* @__PURE__ */ _jsx("g", {
			id: "Layer_2",
			"data-name": "Layer 2",
			children: /* @__PURE__ */ _jsx("g", {
				id: "Layer_1-2",
				"data-name": "Layer 1",
				children: /* @__PURE__ */ _jsx("path", { d: "M21.53,18,36.9,12.4V27.68L21.53,36.06ZM3.22,9.18,20,3.08l16.77,6.1L20,15.28ZM39.43,7.47A3,3,0,0,0,38,6.34L21,.19a3,3,0,0,0-2.11,0L2,6.34A3,3,0,0,0,.55,7.47,3,3,0,0,0,0,9.23V27.68a3,3,0,0,0,.43,1.56,3.07,3.07,0,0,0,1.18,1.13l16.91,9.23a3,3,0,0,0,2.93,0l16.91-9.23a3.07,3.07,0,0,0,1.18-1.13A3,3,0,0,0,40,27.68V9.23A3,3,0,0,0,39.43,7.47Z" })
			})
		})
	]
});
export default SvgIconProduct;
